window.ttx = window.ttx || {};
ttx.loading = {}
ttx.loading = {
    _isLoading: false,
    _instances: {},
    _seed: 1,
    
    getLoad() {
        return this._isLoading;
    },
    
    setLoad(load, callBack) {
        if (this._isLoading === true && load === true) {
            return;
        }

        if (!load) {
            this._isLoading = false;
            callBack && callBack(load);
            return;
        }

        this._isLoading = true;

        this.promise = new Promise((resolve, reject) => {
            callBack && callBack(resolve, reject);
        })
            .then(() => {
            })
            .catch(() => {
            })
            .finally(() => {
                this._isLoading = false;
            });
    },
    
    show(elOrSelector, options) {
        var opts = options || {};
        var useMask = opts.mask === true;
        var color = opts.color;
        if (!color && ttx.theme && ttx.theme.getAccent) {
            color = ttx.theme.getAccent();
        }
        color = color || '#3370ff';
        let targetEl = this._findElement(elOrSelector);

        // [ttx.loading] 日志：记录 show 调用，含目标元素和调用来源，便于排查多个 loading 叠加问题
        var _caller = '';
        try { _caller = (new Error().stack || '').split('\n')[2] || ''; } catch (e) {}
        console.log('%c[ttx.loading] show%c id=loading-' + this._seed + ' target=' + (targetEl ? (targetEl.id || targetEl.className || targetEl.tagName) : 'null') + ' mask=' + useMask + ' caller=' + _caller.trim(),
            'color:#165dff;font-weight:bold', 'color:inherit');
        if (!targetEl) {
            ttx.console.warn('未找到指定的元素:', elOrSelector);
            const useMicroContainer = ttx.micro.isPoweredByHost();

            if (useMicroContainer) {
                targetEl = ttx.micro.getContainer();
            }

            if (!targetEl) {
                targetEl = ttx.utils && typeof ttx.utils.getTopContainer === 'function'
                    ? ttx.utils.getTopContainer()
                    // : this._findElement('#root');
                    : this._findElement('#workbench');
            }
        }

        const id = 'loading-' + this._seed++;

        const overlay = document.createElement('div');
        overlay.id = id;
        overlay.style.cssText = `
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: ${useMask ? 'rgba(255, 255, 255, 0.8)' : 'transparent'};
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 500;
            border-radius: 4px;
            pointer-events: ${useMask ? 'auto' : 'none'};
        `;

        const spinner = document.createElement('div');
        spinner.className = 'tx-loading-spinner';
        spinner.style.cssText = `
            width: 32px;
            height: 32px;
            position: relative;
            animation: tx-loading-rotate 1.2s linear infinite;
        `;

        for (let i = 0; i < 4; i++) {
            const angle = (i * 90) * (Math.PI / 180);
            const angleDeg = i * 90;
            const radius = 10;
            const x = Math.cos(angle) * radius;
            const y = Math.sin(angle) * radius;

            const wrapper = document.createElement('div');
            wrapper.style.cssText = `
                position: absolute;
                left: calc(50% + ${x}px);
                top: calc(50% + ${y}px);
                transform: translate(-50%, -50%) rotate(${angleDeg}deg);
            `;

            const dot = document.createElement('div');
            dot.className = 'tx-loading-dot';
            dot.style.cssText = `
                width: 8px;
                height: 8px;
                background-color: ${color};
                border-radius: 50%;
                animation: tx-loading-dot-pulse 1.2s ease-in-out infinite ${i * 150}ms;
            `;

            wrapper.appendChild(dot);
            spinner.appendChild(wrapper);
        }

        overlay.appendChild(spinner);

        // 仅当 target 计算后的 position 是 static（默认）时才补一个 relative 作为定位基准。
        // 注意：必须用 getComputedStyle 读取最终生效值，而不是 el.style.position（inline style）。
        // 因为很多组件（如 base/Sidebar）的 position 是通过 CSS 类设置的，inline style 为空，
        // 若只判断 inline style 会误把已经有 position:absolute 的元素覆盖成 relative，导致布局 bug。
        //
        // 【关键】这里写入的 inline position 必须能在 hide() 时还原，否则当 target 后续
        // 通过 CSS 类切换 position（如 Sidebar 从 pinned 切到 overlay，position 从 static→absolute）
        // 时，这里写入的 inline relative 会因为优先级高于 CSS 类而残留，覆盖掉新的 absolute。
        var injectedPosition = false;
        var computedPosition = '';
        try {
            computedPosition = window.getComputedStyle(targetEl).position;
        } catch (e) { /* 极端情况下兜底不设置 */ }
        if (computedPosition === 'static' || computedPosition === '') {
            targetEl.style.position = 'relative';
            injectedPosition = true;
        }

        targetEl.appendChild(overlay);
        
        const instance = {
            id,
            element: overlay,
            targetEl,
            // 记录本次 show 是否写入了 inline position，供 hide() 判断是否需要还原
            injectedPosition,
            hide: () => {
                this.hide(id);
            }
        };
        
        this._instances[id] = instance;
        
        return instance;
    },

    /**
     * 页签级 loading：仅在当前激活的页签容器内显示 loading，不影响其他页签
     * @param {Object} [options] - 同 show() 的 options 参数
     * @returns {Object} loading 实例
     */
    showInCurrentTab(options) {
        // 优先查找当前激活的页签容器（由 Core 工程的 transfer/core/index.js 负责注入 data-ttx-tab-active 属性）
        var targetEl = document.querySelector('[data-ttx-tab-active="true"]');

        // [ttx.loading] 日志：记录 showInCurrentTab 调用，含调用来源
        var _caller = '';
        try { _caller = (new Error().stack || '').split('\n')[2] || ''; } catch (e) {}
        console.log('%c[ttx.loading] showInCurrentTab%c target=' + (targetEl ? (targetEl.id || targetEl.className || targetEl.tagName) : 'null') + ' caller=' + _caller.trim(),
            'color:#165dff;font-weight:bold', 'color:inherit');
        if (!targetEl) {
            // 兜底：查找 meta-simple-view 下可见的子元素
            var container = document.querySelector('.meta-simple-view');
            if (container && container.children) {
                var children = container.children;
                for (var i = 0; i < children.length; i++) {
                    if (children[i].style.display !== 'none') {
                        targetEl = children[i];
                        break;
                    }
                }
            }
        }
        // 如果都找不到，回退到全局（例如在非页签场景下调用）
        if (!targetEl) {
            return this.show(null, options);
        }
        return this.show(targetEl, options);
    },
    
    hide(idOrInstance) {
        let instance;
        
        if (typeof idOrInstance === 'string') {
            instance = this._instances[idOrInstance];
        } else if (idOrInstance && typeof idOrInstance === 'object') {
            instance = idOrInstance;
        }

        // [ttx.loading] 日志：记录 hide 调用，含实例 ID 和剩余实例数
        var _remaining = Object.keys(this._instances).length;
        var _id = (instance && instance.id) || (typeof idOrInstance === 'string' ? idOrInstance : 'unknown');
        console.log('%c[ttx.loading] hide%c id=' + _id + ' remaining=' + Math.max(0, _remaining - 1),
            'color:#f53f3f;font-weight:bold', 'color:inherit');

        if (!instance) {
            ttx.console.warn('未找到指定的 loading 实例:', idOrInstance);
            return;
        }
        
        if (instance.element && instance.element.parentNode) {
            instance.element.parentNode.removeChild(instance.element);
        }
        
        // 还原 show 时注入的 inline position：
        // 只有当本次 show 明确写入了 position（injectedPosition === true）才清理，
        // 避免误删业务代码自己设置的 inline position。
        // 这样可以修复"状态翻转后 inline relative 残留覆盖 CSS 类 absolute"的 bug
        // （例如 Sidebar 在 pinned 态被 loading 注入 relative，切到 overlay 态后
        //   CSS 类的 absolute 应该生效，但残留的 inline relative 会覆盖它）。
        if (instance.injectedPosition && instance.targetEl) {
            instance.targetEl.style.removeProperty('position');
        }
        
        Object.keys(this._instances).forEach(key => {
            if (this._instances[key] === instance) {
                delete this._instances[key];
            }
        });
    },
    
    hideAll() {
        Object.keys(this._instances).forEach(key => {
            this.hide(key);
        });
    },
    
    _findElement(elOrSelector) {
        if (!elOrSelector) {
            return null;
        }
        
        if (elOrSelector instanceof HTMLElement) {
            return elOrSelector;
        }
        
        if (typeof elOrSelector === 'string') {
            if (elOrSelector.startsWith('.')) {
                return document.querySelector(elOrSelector);
            } else if (elOrSelector.startsWith('#')) {
                return document.getElementById(elOrSelector.substring(1));
            } else {
                return document.querySelector('.' + elOrSelector) || 
                       document.getElementById(elOrSelector);
            }
        }
        
        return null;
    }
};

if (typeof document !== 'undefined') {
    var oldStyle = document.getElementById('tx-loading-style');
    if (oldStyle) oldStyle.remove();
    const style = document.createElement('style');
    style.id = 'tx-loading-style';
    style.textContent = `
        @keyframes tx-loading-rotate {
            from {
                transform: rotate(0deg);
            }
            to {
                transform: rotate(360deg);
            }
        }

        @keyframes tx-loading-dot-pulse {
            0%, 100% {
                opacity: 1;
                transform: scale(1);
            }
            50% {
                opacity: 0.2;
                transform: scale(0.15);
            }
        }
    `;
    document.head.appendChild(style);
}

// ==================== loadingControl（MDF cb.utils.loadingControl）====================
// 挂到 ttx.utils.loadingControl，供 tx.extend.js / tx.rest.js 调用
// 注意：loading 从无到有约 1.5s 过渡时间，请求在 1.5s 内完成则不会看到加载效果
ttx.utils = ttx.utils || {};
ttx.utils.panelLoading = ttx.utils.panelLoading || {};
ttx.utils.loadingControl = (function () {
    // 各 diworkCode 的引用计数：{ [diworkCode]: count }
    // start 与 end 传相同 diworkCode，调用次数需相同，count 归零才关闭 loading
    var counters = {};
    // 当前显示的 loading 实例
    var loadingInstance = null;
    // 延迟显示定时器（1.5s 过渡，避免快速请求闪烁）
    var showTimer = null;
    var DELAY = 1500;

    // 确保 panelLoading[diworkCode] 调试记录对象存在
    function _ensure(diworkCode) {
        if (!ttx.utils.panelLoading[diworkCode]) {
            ttx.utils.panelLoading[diworkCode] = {
                startLoadingStack: [],
                endLoadingStack: [],
                count: 0
            };
        }
    }

    // 实际显示 loading（复用 ttx.loading.show）
    function _show() {
        if (loadingInstance) return;
        if (ttx.loading && typeof ttx.loading.show === 'function') {
            loadingInstance = ttx.loading.show(null, { mask: true });
        }
    }

    // 实际关闭 loading（复用 ttx.loading.hide）
    function _hide() {
        if (loadingInstance) {
            if (ttx.loading && typeof ttx.loading.hide === 'function') {
                ttx.loading.hide(loadingInstance);
            }
            loadingInstance = null;
        }
    }

    return {
        // 开始 loading：{ diworkCode } 相同的 start/end 需成对调用
        start: function (opts) {
            opts = opts || {};
            var diworkCode = opts.diworkCode || '__default__';
            _ensure(diworkCode);
            // 记录调用堆栈便于排查未成对调用的问题
            try {
                ttx.utils.panelLoading[diworkCode].startLoadingStack.push(new Error().stack);
            } catch (e) { /* 忽略堆栈采集异常 */ }
            counters[diworkCode] = (counters[diworkCode] || 0) + 1;
            ttx.utils.panelLoading[diworkCode].count = counters[diworkCode];

            // loading 从无到有约 1.5s 过渡，请求在 1.5s 内不会看到加载效果
            // 此处延迟 1.5s 再显示，快速请求不会触发可见 loading
            if (!showTimer) {
                showTimer = setTimeout(function () {
                    showTimer = null;
                    _show();
                }, DELAY);
            }
        },
        // 结束 loading：与 start 传相同 diworkCode，引用计数归零时关闭
        end: function (opts) {
            opts = opts || {};
            var diworkCode = opts.diworkCode || '__default__';
            _ensure(diworkCode);
            try {
                ttx.utils.panelLoading[diworkCode].endLoadingStack.push(new Error().stack);
            } catch (e) { /* 忽略堆栈采集异常 */ }
            if (counters[diworkCode] > 0) {
                counters[diworkCode] -= 1;
            }
            ttx.utils.panelLoading[diworkCode].count = counters[diworkCode];

            // 所有 diworkCode 的引用计数都归零时关闭 loading
            var hasPending = false;
            for (var key in counters) {
                if (counters[key] > 0) { hasPending = true; break; }
            }
            if (!hasPending) {
                if (showTimer) {
                    clearTimeout(showTimer);
                    showTimer = null;
                }
                _hide();
            }
        }
    };
})();